module.exports = __webpack_public_path__ + "media/questions.d6e15cb9.mp3";